import React from 'react'
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Box, TextField, Grid } from '@mui/material';
import Button from '@mui/material/Button';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
        width: '600px',
        maxWidth: '60ppx',
    },

    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));
const EditBonusModal = ({ handleCloseOpenEdit, openEdit }) => {
    const [amtValUg, setAmtValUg] = React.useState(4200);
    const [amtValPg, setAmtValPg] = React.useState(5200);
    const [amtVal, setAmtVal] = React.useState(6300);

    return (
        <>

            <BootstrapDialog
                onClose={handleCloseOpenEdit}
                aria-labelledby="customized-dialog-title"
                open={openEdit}
            >
                <Box sx={{ padding: '15px 20px' }}>
                    <Typography sx={{ color: '#15243E', fontSize: '18px', fontWeight: '600' }}>Edit Bonus Amounts</Typography>
                    <Typography sx={{ color: '#363853', fontSize: '14px', fontWeight: '400' }}>Modify cashback amounts for Amity University Online</Typography>
                </Box>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseOpenEdit}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Box>
                        <Box sx={{ marginBottom: '14px' }}>
                            <Typography sx={{ fontSize: '15px', color: '#363853', marginBottom: '6px' }}>
                                New UG Amount (₹)
                            </Typography>
                            <TextField variant="outlined" placeholder='UG Amount (₹)' value={amtValUg} onChange={(e) => setAmtValUg(e.target.value)}
                                sx={{
                                    '& .MuiInputBase-formControl': {
                                        height: '36px',
                                        width: '100%',
                                        borderRadius: '8px'
                                    },
                                    width: '100%'
                                }}
                                type='number'
                            />
                        </Box>
                        <Box sx={{ marginBottom: '14px' }}>
                            <Typography sx={{ fontSize: '15px', color: '#363853', marginBottom: '6px' }}>
                                New PG Amount (₹)
                            </Typography>
                            <TextField variant="outlined" placeholder='New PG Amount (₹)' value={amtValPg} onChange={(e) => setAmtValPg(e.target.value)}
                                sx={{
                                    '& .MuiInputBase-formControl': {
                                        height: '36px',
                                        width: '100%',
                                        borderRadius: '8px'
                                    },
                                    width: '100%'
                                }}
                                type='number'
                            />
                        </Box>
                        <Box sx={{ marginBottom: '14px' }}>
                            <Typography sx={{ fontSize: '15px', color: '#363853', marginBottom: '6px' }}>
                                New Doctorate Amount (₹)
                            </Typography>
                            <TextField
                                variant="outlined"
                                placeholder="New Doctorate Amount (₹)"
                                value={amtVal}
                                onChange={(e) => setAmtVal(e.target.value)}
                                sx={{
                                    '& .MuiInputBase-formControl': {
                                        height: '36px',
                                        width: '100%',
                                        borderRadius: '8px',
                                    },
                                    width: '100%',
                                }}
                                type="number"
                            />
                        </Box>

                        <Box sx={{ marginBottom: '30px', border: '1px solid #1075FF', background: '#EDF4FF', borderRadius: '4px', padding: '12px 14px' }}>
                            <Typography sx={{ fontSize: '16px', color: '#1075FF', marginBottom: '6px' }}>
                                Current Amounts
                            </Typography>
                            <Typography sx={{ color: '#363853', fontSize: '14px', fontWeight: '500' }}>
                                <span> UG: ₹4200.00</span> | <span>PG: ₹4200.00</span> | <span>Doctorate: ₹4200.00</span>
                            </Typography>
                        </Box>
                        <Box>
                            <Grid container spacing={2}>
                                <Grid size={6}>
                                    <Button onClick={handleCloseOpenEdit} variant="outlined" sx={{ textTransform: 'capitalize', width: '100%', borderRadius: '8px', padding: '12px 16px', color: '#363853', fontSize: '15px', border: '1px solid #ddd' }}>Cancel</Button>
                                </Grid>
                                <Grid size={6}>
                                    <Button variant="contained" sx={{ textTransform: 'capitalize', width: '100%', borderRadius: '8px', padding: '12px 16px', color: '#fff', fontSize: '15px', background: '#1075FF' }}>Update Bonus</Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </DialogContent>
            </BootstrapDialog>
        </>
    )
}

export default EditBonusModal